
import { Options, Vue } from "vue-class-component"; //基本需要\
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  readLiveReportList,
  readPerfReport,
  readLivefReport,
  readRecentTaskrecord,
  readTaskRecordDevices,
  readTaskRecordQuery,
  readPerformanceVersion,
  readGetTaskList,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  dispatchGetPerfReport,
  dispatchGetLiverfReport,
  dispatchGetReportDetail,
  // dispatchGetPerformances,
  dispatchUploadReportImage,
  dispatchtaskRecordDevices,
  dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList, //
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchUpdateReport,
  dispatchtaskRecordQuery,
  dispatchAovCopyPerfToReport,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
  dispatchGetTaskList,
  dispatchGetLiveReportList,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";

import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReport extends Vue {
  //声明属性
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public loading = false; //加载
  public FPStrendShow = true;
  public contrast = true;
  新报告数据类型;
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        abs_risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  //获取核心数据的数据类型
  public tableData = [
    {
      date: "0-1min",
      name: "各线去野区进行打野",
      address: "1分钟上线对线",
    },
    {
      date: "1-6min",
      name: "对线(对抗路1V1、中路1V1、发育路2V2，打野做打野行为)",
      address: "3-5.50打野一直在中路抓人",
    },
    {
      date: "6-8min",
      name: "中路和打野去对抗对线打团",
      address: "射手和辅助边路打团(等人齐再开始，死亡后也继续回到线上打团)",
    },
    {
      date: "8-10.30min",
      name: "各边路线去靠近龙坑集合",
      address: "8:30各边开始团战(等人齐再开始，死亡后也继续回到线上打团)",
    },
    {
      date: "10.30-12.30min",
      name: "各边靠近蓝buff进行团战",
      address: "12.30结束团战(等人齐再开始，死亡后也继续回到线上打团)",
    },
    {
      date: "12.30-15min",
      name: "13分中路5v5团战",
      address: "15分结束中团(等人齐再开始，死亡后也继续回到线上打团)",
    },
    {
      date: "15-18:05min",
      name: "红蓝方五个人分别去暴君龙坑打龙和主宰打龙",
      address: "18:05左右自动投降结束",
    },
  ];
  public get test_data() {
    let list = [];
    if (this.localProject != 32) {
      list = [
        {
          name: "中路: A33 小乔 (中路)",
          title: "中路: J200 妲己(中路)",
        },
        {
          name: "暴君路: ROG2 鲁班七号(射手)",
          title: "暴君路: POCO X3 Pro,iphone7p 亚瑟(射手)",
        },
        {
          name: "暴君路: NOTE4 夏侯惇(对抗)",
          title: "暴君路: ROG1,iPhone X 孙尚香(对抗)",
        },
        {
          name: "主宰路: NOTE8 赵云(打野)",
          title: "主宰路: S21 扁鹊(打野)",
        },
        {
          name: "主宰路: Y7 墨子(辅助)",
          title: "主宰路: J7,iphone6P 庄周(辅助)",
        },
      ];
    } else {
      list = [
        {
          name: "中路: X9 小乔 (中路)",
          title: "中路: iphone 妲己(中路)",
        },
        {
          name: "暴君路: ROG1 鲁班七号(射手)",
          title: "暴君路: 荣耀20 孙尚香(射手)",
        },
        {
          name: "暴君路: A33 夏侯惇(对抗)",
          title: "暴君路: iphone7 亚瑟(对抗)",
        },
        {
          name: "主宰路: iphone12 赵云(打野)",
          title: "主宰路: iphone6s plus 扁鹊(打野)",
        },
        {
          name: "主宰路: 荣耀20i 墨子(辅助)",
          title: "主宰路: 红米9T 庄周(辅助)",
        },
      ];
    }

    return list;
  }
  public get_core_data = {
    all_echart_data: [],
    data: "",
    detail: [],
    pkg_name: {},
    project: [],
    real_scenes: [],
    report_list: [],
    report_type: "",
    report_list2: [],
    core_devices: [],
    android: {},
    ios: {},
    off_url: "",
    on_url: "",
    able_versions: {
      android_new_version: "",
      android_old_version: "",
      ios_new_version: "",
      ios_old_version: "",
    },
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        abs_risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
  };
  public old_text() {
    // if(readPerfReport(store).able_versions.android_old_version!=='' && readPerfReport(store).able_versions.ios_old_version==''){
    //   return 'android:'+readPerfReport(store).able_versions.android_old_version
    // }else if(readPerfReport(store).able_versions.android_old_version=='' && readPerfReport(store).able_versions.ios_old_version!==''){
    //    return 'ios'+readPerfReport(store).able_versions.ios_old_version
    // }
    let androidOld = readLivefReport(store).able_versions?.android_old_version;
    let iosOld = readLivefReport(store).able_versions?.ios_old_version;
    if (androidOld !== "" && iosOld == "") {
      return androidOld;
    }
    if (androidOld == "" && iosOld !== "") {
      return iosOld;
    }
    if (androidOld == "" && iosOld == "") {
      return "";
    } else if (androidOld !== "" && iosOld !== "") {
      return "android:" + androidOld + ",ios:" + iosOld;
    }
  }
  public get report_set() {
    const settings = JSON.parse(this.get_core_data.settings);
    return settings.report_settings;
  }
  public get rule_set() {
    const settings = JSON.parse(this.get_core_data.settings);
    return settings.rule_settings;
  }
  //  public scrollBar() {
  //   let obj = document.getElementById("Table_Right_div");
  //   if (
  //     this.get_core_data.report_list2.length > 0 &&
  //     (obj as any).offsetHeight - (obj as any).clientHeight > 0
  //   ) {
  //     this.scroll = true;
  //   } else {
  //     this.scroll = false;
  //   }
  // }

  // 趋势对比
  public compore_num(
    new_value: number,
    old_value: number,
    param: string,
    row?: any,
    device?: any
  ) {
    let level = device?.level;
    let device_type = device?.type;
    if (device_type === 0) {
      device_type = "Android";
    } else if (device_type === 1) {
      device_type = "iOS";
    }
    if (!new_value) {
      return ["", "", ""];
    }
    let res: any = 0;
    if (old_value) {
      res = parseFloat((new_value - old_value).toFixed(1));
    }

    let risk = "";
    let color = ""; // 核心表格差值颜色
    let style = ""; // 核心表格原值颜色
    let new_color = ""; //详情表格差值颜色
    let is_rule = false;
    if (res !== 0) {
      // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(变化值)
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (old_value - new_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              old_value - new_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 按照设备的档位，类型判定风险, 判定规则:新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色配置
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          } else {
            color = "#606266"; // 灰黑色
            new_color = "red";
          }
        }
      } else {
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            typeof this.rule_set.risk_rule?.[param] !== "number" &&
            this.rule_set.risk_rule?.[param].search("%") !== -1
          ) {
            // 阈值类型为百分比: 5%
            if (
              (new_value - old_value) / old_value >
              Number(
                this.rule_set.risk_rule?.[param].substring(
                  0,
                  this.rule_set.risk_rule?.[param].indexOf("%")
                )
              ) *
                0.01
            ) {
              risk = "高风险";
              is_rule = true;
              this.com_risk = "高风险";
            }
          } else {
            // 阈值类型为绝对值: 32
            if (
              new_value - old_value >
              Number(this.rule_set.risk_rule?.[param])
            ) {
              is_rule = true;
              risk = "高风险";
              this.com_risk = "高风险";
            }
          }
        }
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // 颜色规则
        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#606266"; // 灰黑色
            new_color = "red";
          } else {
            color = "#00b050"; // 绿色
            new_color = "#00b050"; // 绿色
          }
        }
      }
      // 指标变化规则判断
      if (row) {
        if (res > 0) {
          res = "(" + Math.abs(res) + "↑" + ")";
        } else if (res < 0) {
          res = "(" + Math.abs(res) + "↓" + ")";
        }
      } else {
        if (res > 0) {
          res = Math.abs(res) + "↑";
        } else if (res < 0) {
          res = Math.abs(res) + "↓";
        }
      }
    } else {
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准, 按照设备的档位，类型判定风险, 判定规则:新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      } else {
        // 风险评估阈值(绝对值)
        if (
          this.rule_set?.abs_risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        // TDR标准
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            style = "color: red; font-weight: bold;";
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      }
      res = row ? "(--)" : "";
    }

    if (risk === "高风险" && row) {
      row[param] = "高风险";
      if (!this.report_set.content.red_only_change_value) {
        style = "color: red; font-weight: bold;";
      }
      if (is_rule) {
        color = "red;font-weight: bold;";
      }
    } else {
      risk = "低风险";
    }
    if (this.report_set.content.core_color_rule) {
      // 核心指标标红规则, 变差就标红
      color = new_color;
    }
    // [差值, 风险, 核心表格差值颜色, 核心表格原值颜色, 详情表格差值颜色]
    return [res, risk, color, style, new_color];
  }
  public get_field(field: string) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      max_pss: "峰值PSS", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "FPS<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "FPS<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
      experienceLoadingTime: "experienceLoadingTime",
    };
    return typeConversion(field, fields, true); //类型转换
  }
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.$route.query.report_id),
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    // this.target_types.map((item, index) => {
    //   this.drawPieChart(index, item.value);
    // });
    this.corePerformance = [];
    await this.getCorePerformance();

    this.loading = false;
  }

  //获取场景iD
  public selected_scene =
    (this.get_core_data.all_echart_data as any[])[0]?.scene_id || "";
  public target_all = {};
  public label_input = "";
  public labelName: any = 0;
  public label_target = "";
  public labelIndex = "";
  public dialogTableVisible = false;
  // 页面初始化
  public async mounted() {
    this.loading = true;
    if (this.$route.query.report_id) {
      if (this.$route.query.project) {
        const project = Number(this.$route.query.project);
        // 记录一下最后访问的项目
        dispatchUpdateMyLastProject(store, { last_visit_project: project });
        saveLocalProject(String(project));
        saveLocalStorageProject(String(project));
        dispatchGetDeviceSpecs(store, {
          project: project,
        });
        dispatchGetDateVersionList(store, {
          project: project,
          report_type: 9,
        });

        dispatchRecentTaskrecord(store, { project: project, report_type: 9 }); //表格对应label
        dispatchGetTaskList(store, { project: project });
        this.reload();
        // 获取当前报告名称列表
        await dispatchGetNewReportList(store, {
          project: this.localProject,
          report_type: 9,
        });
        (this.name_search as any) = Number(this.$route.query.report_id);
        await dispatchGetMobaProjects(store, project);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, project);
        }
        await dispatchGetReportDetail(store, {
          project: project,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetLiverfReport(store, {
          project: project,
          report_id: Number(this.$route.query.report_id),
        });
        // await this.showEdit();
        await this.perf_report();
        this.scene_options; //选择场景

        await this.get_create_report(); //启用生成报告的接口
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD

        this.resBase64 = [];

        //     console.log(this.get_core_data
        // .all_echart_data.length)
        // if(this.get_core_data
        // .all_echart_data.length<=0){
        //   this.ecShow=false
        // }

        // 从浏览器触发发送报告
        if ("screenshot" in this.$route.query) {
          this.save_report();
        }
      } else {
        dispatchGetDeviceSpecs(store, {
          project: this.localProject,
        });
        dispatchGetDateVersionList(store, {
          project: this.localProject,
          report_type: 9,
        });
        dispatchRecentTaskrecord(store, {
          project: this.localProject,
          report_type: 9,
        }); //表格对应label
        dispatchGetTaskList(store, { project: this.localProject });
        await dispatchGetMobaProjects(store, this.localProject);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, this.localProject);
        }
        await dispatchGetReportDetail(store, {
          project: this.localProject,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetLiverfReport(store, {
          project: this.localProject,
          report_id: Number(this.$route.query.report_id),
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口

        await dispatchGetProjectScenes(store, { project: this.localProject });
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD

        this.resBase64 = [];
      }
    } else {
      dispatchGetDateVersionList(store, {
        project: this.localProject,
        report_type: 9,
      });
      dispatchRecentTaskrecord(store, {
        project: this.localProject,
        report_type: 9,
      }); //表格对应label
      dispatchGetTaskList(store, { project: this.localProject });
      // 获取当前报告名称列表
      await dispatchGetNewReportList(store, {
        project: this.localProject,
        report_type: 9,
      });
      // 报告名称
      (this.name_search as any) = readNewReportList(store)[0].id;

      this.$router.push({
        query: { ...this.$route.query, report_id: this.name_search },
      });
      // (this.name_search as any) = this.$route.query.report_id;
      // 邮件标题
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.name_search
      )[0].report_name;
      // 邮件收件人
      // 获取当前报告数据
      await dispatchGetReportDetail(store, {
        project: this.localProject,
        id: Number(this.name_search),
      });
      //调用获取性能报告接口
      await dispatchGetLiverfReport(store, {
        project: this.localProject,
        report_id: Number(this.name_search),
      });
      await dispatchGetProjectDetail(store, {
        id: this.localProject,
        project: this.localProject,
      });
      //启用生成报告的接口
      await this.get_create_report();
      await this.perf_report();
      this.selected_scene =
        (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD

      // 从浏览器触发发送报告
      if ("screenshot" in this.$route.query) {
        this.save_report();
      }
    }
    if (this.localProject !== 8) {
      this.FPStrendShow = false;
    }

    await this.getCorePerformance();
    // await this.getCorePerformance();
    await this.addressee; //解析邮件收件人
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }

    this.target_types?.forEach((item, index) => {
      this.$nextTick(() => {
        this.drawPieChart(index, item);
      });
    });

    // this.drawMap()

    //  await this.scrollBar(); //判断是否有滚动条
    this.loading = false;
  }

  //性能报告核心数据
  public perf_report() {
    this.get_core_data = readLivefReport(store);
  }
  //获取新报告数据
  public get_create_report() {
    this.new_report = readNewReport(store);
    // console.log(readNewReport(store));

    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }
  // 核心指标风险详情
  public drawPieChart(index: any, indexes: string) {
    // 数据

    let ordinates: any[] = [];
    // 初始化数据
    if (this.get_core_data.all_echart_data.length > 0) {
      this.getFPS_RawData.series.forEach((item: any[], i: any) => {
        let target_values: any = [];
        item.forEach((item) => {
          target_values.push(item[this.target_types[index]]);
        });
        ordinates.push({
          name: this.getFPS_RawData.device_names[i],
          type: "line",
          data: target_values,
          smooth: true, // 平滑曲线
          symbol: "circle", //拐点设置为实心
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
        });
      });

      let yAxisSetting: any = {
        type: "value",
        offset: 10,
        axisLabel: {
          formatter: "{value}",
        },
        scale: true,

        // min: function (value: any) {
        //   return Math.ceil(value.min * 0.9);
        // },
        // max: function (value: any) {
        //   return Math.ceil(value.max * 1.05);
        // },
      };
      if (indexes === "lag_pcnt") {
        yAxisSetting = {
          type: "value",
          offset: 10,
          axisLabel: {
            formatter: "{value}",
          },
          max: function (value: any) {
            return Math.ceil(value.max * 1.05);
          },
        };
      }

      // let performance_line: any = document.getElementById(
      //   "performance_line" + indexes
      // );
      let toolbox: any = {
        feature: {
          saveAsImage: {},
        },
      };
      if ("screenshot" in this.$route.query) {
        toolbox = {};
      }
      let c = "performance_line" + indexes;
      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决

      let PerformanceLineChart = echarts.init(
        this.$refs["performance_line" + indexes] as any
      );
      ordinates[0].markLine = {
        data: [],
      };
      ordinates[0].markLine.data = this.target_all[this.selected_scene][
        indexes
      ];
      let nameLabel = "5V5真人PVP剧本";
      if (this.localProject == 34) {
        PerformanceLineChart.on("click", (params) => {
          // ordinates[0].markLine={}

          this.labelIndex = index;

          this.label_target = indexes;
          if (params.componentType == "series") {
            this.labelName = params.name;
            this.dialogTableVisible = true;

            this.labelIndex = index;

            this.label_target = indexes;
          }
          if (params.componentType === "markLine") {
            (this as any)
              .$confirm(
                "删除标记点: " +
                  this.target_all[nameLabel][indexes].filter(
                    (v) => v.xAxis === params.value
                  )[0].label.normal.formatter +
                  "?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
              .then(() => {
                let i = -1;

                this.target_all[nameLabel][indexes].forEach((item, index) => {
                  if (item.xAxis === params.value) {
                    i = index;
                  }
                });
                this.target_all[nameLabel][indexes].splice(i, 1);
                const settings = JSON.parse(this.new_report.settings);
                settings.label_formatter = this.target_all;
                dispatchUpdateReport(store, {
                  project: this.localProject,
                  id: Number(this.name_search),

                  settings: JSON.stringify(settings),
                });
                (this as any).$message({
                  type: "success",
                  message: "删除成功",
                });
                PerformanceLineChart.setOption({
                  series: ordinates,
                });
              });
          }
        });
      }
      let option;
      option = {
        title: {
          left: "center",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
          data: this.getFPS_RawData.device_names,
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "20%",
          right: "4%",
          containLabel: true,
        },
        toolbox: toolbox,
        animation: false,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: (this.getFPS_RawData.x_axis_format as any[]).map((item) =>
            item.indexOf("(") !== -1 ? item.split("(")[0] + "]" : item
          ),
          // data: game_versions,
          // offset: 10,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: yAxisSetting,
        series: ordinates,
        judge:
          ordinates.filter((item: any) => item.data.length === 0).length ===
          ordinates.length
            ? true
            : false,
      };
      PerformanceLineChart.setOption(option);
      PerformanceLineChart.resize();

      var res_base64 = PerformanceLineChart.getDataURL({
        excludeComponents: ["toolbox"],
      }); //拿到base64 地址，就好下载了。
      let res: any = {};
      res.file_base64 = res_base64;
      res.filename =
        "report" +
        index +
        "_project" +
        this.localProject +
        "_report" +
        this.$route.query.report_id +
        ".png";
      res.scene_chinese = this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0].chinese;
      res.indexes = this.get_field(indexes);
      this.resBase64.push(res);
      this.removeDuplicates(this.resBase64);
      //  let  newData = [...this.resBase64]
      //  let  hash = {};
      //  this.resBase64 = newData.reduce(function (item, next) {
      //    hash[next.value] ? '' : hash[next.value] = true && item.push(next);
      //       return item
      //     }, [])

      return PerformanceLineChart;
    }
  }
  public corePerformance: any[] = [];
  // 核心指标性能数据
  // public getCorePerformance() {
  //   if (this.get_core_data.report_list.length > 0) {
  //     this.corePerformance.push({
  //       title: "新场景:",
  //       data: this.get_core_data.report_list,
  //       compare: this.get_core_data.core_devices1,
  //       edition: this.get_core_data.old_version,
  //     });
  //   }
  //   if (this.get_core_data.report_list1.length > 0) {
  //     this.corePerformance.push({
  //       title: "老场景:",
  //       data: this.get_core_data.report_list1,
  //       compare: this.get_core_data.core_devices2,
  //       edition: this.get_core_data.old_version1,
  //     });
  //   }
  //   return this.corePerformance;
  // }

  //将新报告的JSON 字符串转换为对象。
  // public get report_set() {
  //   const settings = JSON.parse(this.new_report.settings);
  //   return settings.report_settings;
  // }
  // public imgData: any = [];
  // // 数值变化的规则配置
  // public get rule_set() {
  //   const settings = JSON.parse(this.new_report.settings);
  //   return settings.rule_settings;
  // }
  // 趋势对比
  // public compore_num(
  //   new_value: number,
  //   old_value: number,
  //   param: string,
  //   row?: any,
  //   device?: any
  // ) {
  //   let level = device?.level;
  //   let device_type = device?.type;
  //   if (device_type === 0) {
  //     device_type = "Android";
  //   } else if (device_type === 1) {
  //     device_type = "iOS";
  //   }
  //   if (!new_value) {
  //     return ["", "", ""];
  //   }
  //   let res: any = 0;
  //   if (old_value) {
  //     res = parseFloat((new_value - old_value).toFixed(1));
  //   }

  //   let risk = "";
  //   let color = ""; // 核心表格差值颜色
  //   let style = ""; // 核心表格原值颜色
  //   let new_color = ""; //详情表格差值颜色
  //   let is_rule = false;
  //   if (res !== 0) {
  //     // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
  //     if (this.rule_set.change_rule.increase_good.includes(param)) {
  //       // 风险评估阈值(变化值)
  //       if (
  //         this.rule_set.risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           typeof this.rule_set.risk_rule?.[param] !== "number" &&
  //           this.rule_set.risk_rule?.[param].search("%") !== -1
  //         ) {
  //           // 阈值类型为百分比: 5%
  //           if (
  //             (old_value - new_value) / old_value >
  //             Number(
  //               this.rule_set.risk_rule?.[param].substring(
  //                 0,
  //                 this.rule_set.risk_rule?.[param].indexOf("%")
  //               )
  //             ) *
  //               0.01
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         } else {
  //           // 阈值类型为绝对值: 32
  //           if (
  //             old_value - new_value >
  //             Number(this.rule_set.risk_rule?.[param])
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         }
  //       }
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 按照设备的档位，类型判定风险, 判定规则:新版本数值超过阈值
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value <
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 颜色配置
  //       if (this.rule_set.change_rule.threshold?.[param]) {
  //         if (
  //           Math.abs(new_value - old_value) / old_value >
  //           this.rule_set.change_rule.threshold?.[param]
  //         ) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         }
  //       } else {
  //         if (res > 0) {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         } else {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         }
  //       }
  //     } else {
  //       if (
  //         this.rule_set.risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           typeof this.rule_set.risk_rule?.[param] !== "number" &&
  //           this.rule_set.risk_rule?.[param].search("%") !== -1
  //         ) {
  //           // 阈值类型为百分比: 5%
  //           if (
  //             (new_value - old_value) / old_value >
  //             Number(
  //               this.rule_set.risk_rule?.[param].substring(
  //                 0,
  //                 this.rule_set.risk_rule?.[param].indexOf("%")
  //               )
  //             ) *
  //               0.01
  //           ) {
  //             risk = "高风险";
  //             is_rule = true;
  //             this.com_risk = "高风险";
  //           }
  //         } else {
  //           // 阈值类型为绝对值: 32
  //           if (
  //             new_value - old_value >
  //             Number(this.rule_set.risk_rule?.[param])
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         }
  //       }
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value >
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 颜色规则
  //       if (this.rule_set.change_rule.threshold?.[param]) {
  //         if (
  //           Math.abs(new_value - old_value) / old_value >
  //           this.rule_set.change_rule.threshold?.[param]
  //         ) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         }
  //       } else {
  //         if (res > 0) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050"; // 绿色
  //         }
  //       }
  //     }
  //     // 指标变化规则判断
  //     if (row) {
  //       if (res > 0) {
  //         res = "(" + Math.abs(res) + "↑" + ")";
  //       } else if (res < 0) {
  //         res = "(" + Math.abs(res) + "↓" + ")";
  //       }
  //     } else {
  //       if (res > 0) {
  //         res = Math.abs(res) + "↑";
  //       } else if (res < 0) {
  //         res = Math.abs(res) + "↓";
  //       }
  //     }
  //   } else {
  //     if (this.rule_set.change_rule.increase_good.includes(param)) {
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准, 按照设备的档位，类型判定风险, 判定规则:新版本数值超过阈值
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value <
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //     } else {
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value >
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //     }
  //     res = row ? "(--)" : "";
  //   }

  //   if (risk === "高风险" && row) {
  //     row[param] = "高风险";
  //     if (!this.report_set.content.red_only_change_value) {
  //       style = "color: red; font-weight: bold;";
  //     }
  //     if (is_rule) {
  //       color = "red;font-weight: bold;";
  //     }
  //   } else {
  //     risk = "低风险";
  //   }
  //   if (this.report_set.content.core_color_rule) {
  //     // 核心指标标红规则, 变差就标红
  //     color = new_color;
  //   }
  //   // [差值, 风险, 核心表格差值颜色, 核心表格原值颜色, 详情表格差值颜色]
  //   return [res, risk, color, style, new_color];
  // }
  public async labelBtn() {
    if (this.label_input) {
      let nameLabel = "5V5真人PVP剧本";
      this.target_all[nameLabel][this.label_target].push({
        silent: false,
        xAxis: this.labelName,
        label: {
          normal: {
            show: true,
            position: "end",
            formatter: this.label_input,
            textStyle: {
              color: "black", //标注线终点文字颜色
              fontSize: 16,
              fontWeight: 800,
              padding: [0, 0, 10, 0], //文字间距
            },
          },
        },
        lineStyle: {
          // type: "solid",
          color: "#ED5664",
          width: "3",
          fontSize: 15,
        },
      });

      this.drawPieChart(this.labelIndex, this.label_target);
      this.resBase64 = [];
      this.target_types.map((item, index) => {
        this.drawPieChart(index, item);
      });
      const settings = JSON.parse(this.new_report.settings);
      settings.label_formatter = this.target_all;
      this.dialogTableVisible = false;
      ElMessage({
        message: "添加成功",
        type: "success",
      });
      await dispatchUpdateReport(store, {
        project: this.localProject,
        id: Number(this.name_search),

        settings: JSON.stringify(settings),
      });
    } else {
      ElMessage.error("请输入内容或者取消");
    }
    // this.dialogTableVisible=false
  }
  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }
  public get get_scene_chinese() {
    return (
      this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0]?.chinese || "-"
    );
  }
  public ecShow = true;
  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }

  //场景选项
  public get scene_options() {
    const scene = readLivefReport(store).all_echart_data; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene_id,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  public get scene_options1() {
    const scene = readLivefReport(store).auto_roadmap; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  // 获取机型
  public selected_device = "";

  // 指标选项
  // public get target_types() {
  //   let target_select: any[] = [];
  //   this.report_set.content.trend_index.forEach((item: any) => {
  //     target_select.push({
  //       label: this.get_field(item),
  //       value: item,
  //     });
  //   });
  //   return target_select;
  // }
  public async recordChange() {
    this.loading = true;
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.$route.query.report_id),
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    await this.perf_report();

    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });

    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    await this.addressee; //解析邮件收件人
    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }
  //点击切换场景时触发

  //   public auto_roadmap=[{a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"地铁副本测试"},
  // {a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"黑铁"}
  // ]
  public filterList = {
    pick: "",
    version: "",
    subType: "",
  };
  public recordList = [];
  public versionShow = true;
  public async date(type) {
    let newDate1 = "";
    if (this.filterList.pick != "") {
      let newDate = dateConversion(this.filterList.pick);
      newDate1 = /\d{4}-\d{1,2}-\d{1,2}/g.exec(newDate)[0];
    }

    // if(type=='pick'){

    // console.log(newDate1)
    // let list=[]
    // // this.RecentTaskrecord.forEach(v=>{
    // //   console.log(v.label.split(' ')[2])
    // //   console.log(v)
    // //   console.log(v.label.split(' ')[2]===newDate1)
    // //   if(v.label.split(' ')[2]===newDate1){
    // //    list.push(v)

    // //   }
    // // })
    // this.versionShow=false
    // this.recordList=list
    // this.filterList.version=''
    // this.filterList.subType=''
    // this.versionShow=true

    // console.log(this.filterList.version)

    // }

    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: "",
      create_date: this.filterList.pick === "" ? "" : newDate1,
      task_id: this.filterList.version === "" ? "" : this.filterList.version,
      subtype: this.filterList.subType == "" ? "" : this.filterList.subType,
    });
    // await dispatchGetNewReportList(store, {
    //   project: this.localProject,
    //   report_type: 9,
    // });

    if (readNewReportList(store).length <= 0) {
      alert("暂未查询到数据,请重新选择");
    } else {
      this.loading = true;
      await this.nameList;
      this.name_search = readNewReportList(store)[0].id;
      this.$router.push({
        query: { ...this.$route.query, report_id: this.name_search },
      });
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.name_search
      )[0].report_name;
      // 邮件收件人
      // 获取当前报告数据
      await dispatchGetReportDetail(store, {
        project: this.localProject,
        id: Number(this.name_search),
      });
      //调用获取性能报告接口
      // await dispatchGetPerfReport(store, {
      //   project: this.localProject,
      //   report_id: Number(this.name_search),
      // });
      await dispatchGetLiverfReport(store, {
        project: this.localProject,
        report_id: Number(this.$route.query.report_id),
      });
      //启用生成报告的接口
      await this.get_create_report();
      await this.perf_report();

      // this.selected_scene =
      //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
      // if (this.report_set.content.trend_scene) {
      //   if (this.report_set.content.trend_scene.length !== 0) {
      //     this.selected_scene = this.report_set.content.trend_scene[0];
      //   }
      // }
      // if (this.get_core_data.auto_roadmap != undefined) {
      //   this.selected_scene1 =
      //     (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
      //   this.imgData = readLivefReport(store).auto_roadmap[0]?.roadmap;
      //   // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
      // }
      this.resBase64 = [];
      let settings = JSON.parse(this.new_report.settings);
      this.target_all = {};
      let nameLabel = "5V5真人PVP剧本";
      this.target_all[nameLabel] = {};
      this.target_types.map((item, index) => {
        this.target_all[nameLabel][item] = [];
      });
      for (let i in this.target_all) {
        if (settings.label_formatter) {
          if (settings?.label_formatter[i]) {
            for (let k in settings.label_formatter[i]) {
              this.target_all[i][k] = settings.label_formatter[i][k];
            }
          }
        }
      }
      this.$nextTick(() => {
        this.target_types?.forEach((item, index) => {
          this.drawPieChart(index, item);
        });
      });

      // 从浏览器触发发送报告
      if ("screenshot" in this.$route.query) {
        this.save_report();
      }

      // await dispatchtaskRecordDevices(store, {
      //   project: this.localProject,
      //   task_record_id: "",
      // }); //获取任务记录的设备
      this.corePerformance = [];
      await this.getCorePerformance();

      this.loading = false;
    }
  }
  // public async selectSceneChange1(event: any) {
  //   let imgList = readLivefReport(store).auto_roadmap.filter(
  //     (v: any) => v.scene === event
  //   );
  //   this.imgData = imgList[0].roadmap;
  // }
  // 点击切换机型的时候触发

  //点击切换指标时触发
  // public selectChange() {
  //   this.resBase64 = [];
  //   this.target_types.map((item, index) => {
  //     this.drawPieChart(index, item.value);
  //   });
  // }
  public subChart: any = [];
  //绘制图表准备
  // 原始数据处理
  public get getFPS_RawData() {
    const FPS_RawData: any = (this.get_core_data
      .all_echart_data as any[]).filter(
      (item: any) => item.scene_id === this.selected_scene
    )[0]?.echart_data;
    return FPS_RawData;
    // return FPS_RawData.reverse();
  }
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  // 绘制图表
  // public drawPieChart(index: any, indexes: string) {
  //   // 数据
  //   let ordinates: any[] = [];
  //   // 初始化数据
  //   if (this.get_core_data.all_echart_data.length > 0) {
  //     this.getFPS_RawData.series.forEach((item: any[], i: any) => {
  //       let target_values: any = [];
  //       item.forEach((item) => {
  //         target_values.push(item[this.target_types[index].value]);
  //       });
  //       ordinates.push({
  //         name: this.getFPS_RawData.device_names[i],
  //         type: "line",
  //         data: target_values,
  //         smooth: true, // 平滑曲线
  //         symbol: "circle", //拐点设置为实心
  //         itemStyle: {
  //           normal: {
  //             label: {
  //               // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
  //               show: true,
  //             },
  //           },
  //         },
  //       });
  //     });

  //     let yAxisSetting: any = {
  //       type: "value",
  //       offset: 10,
  //       axisLabel: {
  //         formatter: "{value}",
  //       },
  //       scale: true,

  //       // min: function (value: any) {
  //       //   return Math.ceil(value.min * 0.9);
  //       // },
  //       // max: function (value: any) {
  //       //   return Math.ceil(value.max * 1.05);
  //       // },
  //     };
  //     if (indexes === "lag_pcnt") {
  //       yAxisSetting = {
  //         type: "value",
  //         offset: 10,
  //         axisLabel: {
  //           formatter: "{value}",
  //         },
  //         max: function (value: any) {
  //           return Math.ceil(value.max * 1.05);
  //         },
  //       };
  //     }

  //     let performance_line: any = document.getElementById(
  //       "performance_line" + index
  //     );
  //     let toolbox: any = {
  //       feature: {
  //         saveAsImage: {},
  //       },
  //     };
  //     if ("screenshot" in this.$route.query) {
  //       toolbox = {};
  //     }

  //     // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
  //     // echarts数据变动时, 数据正常，图标混乱，故以此解决
  //     echarts.dispose(performance_line);
  //     let PerformanceLineChart = echarts.init(performance_line);
  //     let option;
  //     option = {
  //       title: {
  //         left: "center",
  //         textStyle: {
  //           fontSize: 16,
  //           fontWeight: "normal",
  //         },
  //       },
  //       tooltip: {
  //         trigger: "axis",
  //       },
  //       legend: {
  //         x: "center",
  //         y: "bottom",
  //         padding: [0, 0, 10, 0],
  //         // data: devices.map(
  //         //   (item) =>
  //         //     this.getDeviceSpecs.filter(
  //         //       (device) => device.id === item.device_id
  //         //     )[0]?.model.name
  //         // ),
  //         data: this.getFPS_RawData.device_names,
  //       },
  //       grid: {
  //         left: "4%",
  //         top: "10%",
  //         bottom: "20%",
  //         right: "4%",
  //         containLabel: true,
  //       },
  //       toolbox: toolbox,
  //       animation: false,
  //       xAxis: {
  //         type: "category",
  //         boundaryGap: false,
  //         data: (this.getFPS_RawData.x_axis_format as any[]).map((item) =>
  //           item.indexOf("(") !== -1 ? item.split("(")[0] + "]" : item
  //         ),
  //         // data: game_versions,
  //         // offset: 10,
  //         axisLabel: {
  //           interval: 0,
  //         },
  //       },
  //       yAxis: yAxisSetting,
  //       series: ordinates,
  //       judge:
  //         ordinates.filter((item: any) => item.data.length === 0).length ===
  //         ordinates.length
  //           ? true
  //           : false,
  //     };
  //     PerformanceLineChart.setOption(option);
  //     PerformanceLineChart.resize();
  //     if (option.judge === true) {
  //       performance_line.parentNode.parentNode.setAttribute(
  //         "style",
  //         "display:none"
  //       );
  //       this.subChart.push(index);
  //     }
  //     var res_base64 = PerformanceLineChart.getDataURL({
  //       excludeComponents: ["toolbox"],
  //     }); //拿到base64 地址，就好下载了。
  //     let res: any = {};
  //     res.file_base64 = res_base64;
  //     res.filename =
  //       "report" +
  //       index +
  //       "_project" +
  //       this.localProject +
  //       "_report" +
  //       this.$route.query.report_id +
  //       ".png";
  //     res.scene_chinese = this.scene_options.filter(
  //       (item) => item.scene_id === this.selected_scene
  //     )[0].chinese;
  //     res.indexes = this.get_field(indexes);
  //     this.resBase64.push(res);
  //     this.removeDuplicates(this.resBase64);
  //     //  let  newData = [...this.resBase64]
  //     //  let  hash = {};
  //     //  this.resBase64 = newData.reduce(function (item, next) {
  //     //    hash[next.value] ? '' : hash[next.value] = true && item.push(next);
  //     //       return item
  //     //     }, [])

  //     return PerformanceLineChart;
  //   }
  // }
  public removeDuplicates(arr: any) {
    const result: any = [];
    const duplicatesIndices: any = [];

    // 循环遍历原始数组中的每个项
    arr.forEach((current: any, index: any) => {
      if (duplicatesIndices.includes(index)) return;

      result.push(current);

      // 循环遍历数组中当前项之后的其他项
      for (
        let comparisonIndex = index + 1;
        comparisonIndex < arr.length;
        comparisonIndex++
      ) {
        const comparison = arr[comparisonIndex];
        const currentKeys = Object.keys(current);
        const comparisonKeys = Object.keys(comparison);

        // 检查对象中的键数
        if (currentKeys.length !== comparisonKeys.length) continue;

        // 检查关键字名称
        const currentKeysString = currentKeys.sort().join("").toLowerCase();
        const comparisonKeysString = comparisonKeys
          .sort()
          .join("")
          .toLowerCase();
        if (currentKeysString !== comparisonKeysString) continue;

        // 检查值
        let valuesEqual = true;
        for (let i = 0; i < currentKeys.length; i++) {
          const key = currentKeys[i];
          if (current[key] !== comparison[key]) {
            valuesEqual = false;
            break;
          }
        }
        if (valuesEqual) duplicatesIndices.push(comparisonIndex);
      }
    });

    return result;
  }
  //   public drawMap(){
  //      var chartDom = document.getElementById("map") as HTMLElement;
  //     var contrastChart = echarts.init(chartDom);
  //     const hours = [
  //     '12a', '1a', '2a', '3a', '4a', '5a', '6a',
  //     '7a', '8a', '9a', '10a', '11a',
  //     '12p', '1p', '2p', '3p', '4p', '5p',
  //     '6p', '7p', '8p', '9p', '10p', '11p'
  // ];
  // // prettier-ignore
  // const days = [
  //     'Saturday', 'Friday', 'Thursday',
  //     'Wednesday', 'Tuesday', 'Monday', 'Sunday'
  // ];
  // // prettier-ignore
  // const data = [[0, 0, 5], [0, 1, 1], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 2], [0, 12, 4], [0, 13, 1], [0, 14, 1], [0, 15, 3], [0, 16, 4], [0, 17, 6], [0, 18, 4], [0, 19, 4], [0, 20, 3], [0, 21, 3], [0, 22, 2], [0, 23, 5], [1, 0, 7], [1, 1, 0], [1, 2, 0], [1, 3, 0], [1, 4, 0], [1, 5, 0], [1, 6, 0], [1, 7, 0], [1, 8, 0], [1, 9, 0], [1, 10, 5], [1, 11, 2], [1, 12, 2], [1, 13, 6], [1, 14, 9], [1, 15, 11], [1, 16, 6], [1, 17, 7], [1, 18, 8], [1, 19, 12], [1, 20, 5], [1, 21, 5], [1, 22, 7], [1, 23, 2], [2, 0, 1], [2, 1, 1], [2, 2, 0], [2, 3, 0], [2, 4, 0], [2, 5, 0], [2, 6, 0], [2, 7, 0], [2, 8, 0], [2, 9, 0], [2, 10, 3], [2, 11, 2], [2, 12, 1], [2, 13, 9], [2, 14, 8], [2, 15, 10], [2, 16, 6], [2, 17, 5], [2, 18, 5], [2, 19, 5], [2, 20, 7], [2, 21, 4], [2, 22, 2], [2, 23, 4], [3, 0, 7], [3, 1, 3], [3, 2, 0], [3, 3, 0], [3, 4, 0], [3, 5, 0], [3, 6, 0], [3, 7, 0], [3, 8, 1], [3, 9, 0], [3, 10, 5], [3, 11, 4], [3, 12, 7], [3, 13, 14], [3, 14, 13], [3, 15, 12], [3, 16, 9], [3, 17, 5], [3, 18, 5], [3, 19, 10], [3, 20, 6], [3, 21, 4], [3, 22, 4], [3, 23, 1], [4, 0, 1], [4, 1, 3], [4, 2, 0], [4, 3, 0], [4, 4, 0], [4, 5, 1], [4, 6, 0], [4, 7, 0], [4, 8, 0], [4, 9, 2], [4, 10, 4], [4, 11, 4], [4, 12, 2], [4, 13, 4], [4, 14, 4], [4, 15, 14], [4, 16, 12], [4, 17, 1], [4, 18, 8], [4, 19, 5], [4, 20, 3], [4, 21, 7], [4, 22, 3], [4, 23, 0], [5, 0, 2], [5, 1, 1], [5, 2, 0], [5, 3, 3], [5, 4, 0], [5, 5, 0], [5, 6, 0], [5, 7, 0], [5, 8, 2], [5, 9, 0], [5, 10, 4], [5, 11, 1], [5, 12, 5], [5, 13, 10], [5, 14, 5], [5, 15, 7], [5, 16, 11], [5, 17, 6], [5, 18, 0], [5, 19, 5], [5, 20, 3], [5, 21, 4], [5, 22, 2], [5, 23, 0], [6, 0, 1], [6, 1, 0], [6, 2, 0], [6, 3, 0], [6, 4, 0], [6, 5, 0], [6, 6, 0], [6, 7, 0], [6, 8, 0], [6, 9, 0], [6, 10, 1], [6, 11, 0], [6, 12, 2], [6, 13, 1], [6, 14, 3], [6, 15, 4], [6, 16, 0], [6, 17, 0], [6, 18, 0], [6, 19, 0], [6, 20, 1], [6, 21, 2], [6, 22, 2], [6, 23, 6]]
  //     .map(function (item) {
  //     return [item[1], item[0], item[2] || '-'];
  // });

  // var img = new Image();
  // 	img.src = 'https://img2.baidu.com/it/u=2220565380,2694932281&fm=253&fmt=auto&app=138&f=JPEG?w=700&h=466';

  //   let option={}
  //   option = {

  // 		backgroundColor :{
  // 			image: require('../../assets/test/map.jpg'),
  // 			repeat: "no-repeat"
  // 		},
  //        tooltip: {
  //     position: 'top'
  //   },
  //   grid: {
  //     height: '50%',
  //     top: '10%'
  //   },
  //   xAxis: {
  //     type: 'category',
  //     data: hours,
  //     splitArea: {
  //       show: true
  //     },

  //     show: false
  //   },
  //   yAxis: {
  //     type: 'category',
  //     data: days,
  //     splitArea: {
  //       show: true
  //     },
  //     show: false
  //   },
  //   visualMap: {
  //     min: 0,
  //     max: 10,
  //     calculable: true,
  //     orient: 'horizontal',
  //     left: 'center',
  //     bottom: '15%',
  //     show:false,
  //     inRange:{
  //             color: ['rgba(0,255,0,0.1)','rgba(255,255,0,0.7)', 'rgba(255,0,0,0.1)']
  //         }
  //   },
  //   series: [
  //     {
  //       name: 'Punch Card',
  //       type: 'heatmap',
  //       data: data,
  //       label: {
  //         show: true
  //       },
  //       emphasis: {
  //         itemStyle: {
  //           shadowBlur: 10,
  //           shadowColor: 'rgba(0, 0, 0, 0.5)'
  //         }
  //       },

  //     }
  //   ]

  // 	}

  // 		contrastChart.setOption(option)

  //   }
  // public drawcontrastChart() {
  //   let trend: any = {};
  //   var chartDom = document.getElementById("contrast_left") as HTMLElement;
  //   var contrastChart = echarts.init(chartDom);

  //   (this.get_core_data.version_comparison_list as any).forEach((v: any) => {
  //     if (v.scene_id == this.selected_scene) {
  //       trend = v;
  //     }
  //   });

  //   contrastChart.setOption({
  //     title: {
  //       text: "平均FPS",
  //       textStyle: {
  //         fontSize: 13,
  //       },
  //     },
  //     xAxis: {
  //       type: "category",
  //       data: trend.device_list,
  //     },
  //     yAxis: {
  //       type: "value",
  //     },
  //     legend: {
  //       data: trend.version_list,
  //     },
  //     animation: false,
  //     series: [
  //       {
  //         name: trend.version_list[0],
  //         data: trend.data.avg_fps[0],
  //         type: "bar",
  //         label: {
  //           show: true,
  //           position: "top",
  //         },
  //       },
  //       {
  //         name: trend.version_list[1],
  //         data: trend.data.avg_fps[1],
  //         type: "bar",
  //         label: {
  //           show: true,
  //           position: "top",
  //         },
  //       },
  //     ],
  //   });
  //   var res_base64 = contrastChart.getDataURL({
  //     excludeComponents: ["toolbox"],
  //   }); //拿到base64 地址，就好下载了。
  //   let res: any = {};
  //   res.file_base64 = res_base64;
  //   res.filename = "version_compare_fps.png";
  //   res.scene_chinese = this.scene_options.filter(
  //     (item) => item.scene_id === this.selected_scene
  //   )[0].chinese;
  //   res.indexes = "version_compare_fps";
  //   this.resBase64.push(res);
  // }
  // public drawcontrastChart2() {
  //   let trend: any = {};
  //   var chartDom = document.getElementById("contrast_right") as HTMLElement;
  //   var contrastChart = echarts.init(chartDom);
  //   (this.get_core_data.version_comparison_list as any).forEach((v: any) => {
  //     if (v.scene_id == this.selected_scene) {
  //       trend = v;
  //     }
  //   });
  //   contrastChart.setOption({
  //     title: {
  //       text: "MaxPss",
  //       textStyle: {
  //         fontSize: 13,
  //       },
  //     },
  //     xAxis: {
  //       type: "category",
  //       data: trend.device_list,
  //     },
  //     yAxis: {
  //       type: "value",
  //     },
  //     animation: false,
  //     legend: {
  //       data: trend.version_list,
  //     },
  //     series: [
  //       {
  //         name: trend.version_list[0],
  //         data: trend.data.max_pss[0],
  //         type: "bar",
  //         label: {
  //           show: true,
  //           position: "top",
  //         },
  //       },
  //       {
  //         name: trend.version_list[1],
  //         data: trend.data.max_pss[1],
  //         type: "bar",
  //         label: {
  //           show: true,
  //           position: "top",
  //         },
  //       },
  //     ],
  //   });
  //   var res_base64 = contrastChart.getDataURL({
  //     excludeComponents: ["toolbox"],
  //   }); //拿到base64 地址，就好下载了。
  //   let res: any = {};
  //   res.file_base64 = res_base64;
  //   res.filename = "version_compare_pss.png";
  //   res.scene_chinese = this.scene_options.filter(
  //     (item) => item.scene_id === this.selected_scene
  //   )[0].chinese;
  //   res.indexes = "version_compare_pss";
  //   this.resBase64.push(res);
  // }

  //报告筛选部分
  //风险等级
  public status_search: string | "" = "";
  public status_options = [
    {
      label: "高风险",
      value: "高风险",
    },
    {
      label: "低风险",
      value: "低风险",
    },
  ];
  //报告名称
  public name_search = "";
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 编辑
  public dialogFormVisible1 = false;
  public formLabelWidth = "";
  public form1 = {
    name: "",
    type: "",
  };

  // public showEdit(){
  //   this.dialogFormVisible1 = true;
  //   console.log(this.name_search)
  //   this.form1.name=(readNewReportList(store) as any[]).filter(
  //       (item: any) => item.id === this.name_search
  //     )[0].report_name;
  // }
  public handleEdit() {
    this.dialogFormVisible1 = true;
    this.form1.name = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;

    this.form1.type = String((readNewReport(store) as any).subtype);

    // this.form1.name=edit_name.slice(0,edit_name.indexOf('】')+1)
  }

  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateReport(store, {
      project: this.localProject,
      id: Number(this.name_search),
      report_name: String(this.form1.name),
      subtype: Number(this.form1.type),
    });
    (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name = this.form1.name;
  }
  // 邮件
  public get target_types() {
    return this.dataTable;
  }
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  // 对比数据
  public contrasts = {
    record_list: [],
    old_record_list: [],
  };
  public target(a: any) {
    if (
      (this.localProject == 34 ||
        this.localProject == 40 ||
        this.localProject == 47) &&
      a != undefined
    ) {
      window.open(this.get_url(a), "_blank");
    } else {
      return;
    }
  }
  // 复制数据
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  public get sceneList() {
    return [
      "整局FPS",
      "团战FPS",
      "PSS峰值",
      "PSS均值",
      "平均CPU",
      "Loading",
      "ExperienceLoading",
    ];
  }
  public get testConclusion() {
    let list = [];
    this.sceneList.forEach((v, index) => {
      list.push({
        name: v,
        id: 1,
        android: this.get_core_data.android[v],
        ios: this.get_core_data.ios[v],
      });
    });
    list.forEach((v, index) => {
      if (index === 0 || index === 1) {
        v.android1 = [];
        v.android1 = v.android;
        v.ios1 = [];
        v.ios1 = v.ios;
      }
    });
    if (this.localProject !== 32) {
      return list;
    } else {
      return list.filter((v) => v.name !== "ExperienceLoading");
    }
  }
  // 点击删除
  public async handleDelete() {
    this.loading = true;

    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    // await dispatchGetNewReportList(store, {
    //   project: this.localProject,
    //   report_type: 9,
    // });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 9,
    });
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });

    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.name_search),
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();

    this.loading = false;
  }

  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public resBase64: any[] = [];
  //发送报告
  public async save_report(is_auto?: boolean) {
    let upload_data: any;
    this.resBase64 = [];
    await this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.removeDuplicates(this.resBase64),
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
        report_type: 12,
      };
    } else {
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.removeDuplicates(this.resBase64),
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
        report_type: 9,
      };
    }

    await dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 判断安卓/ios
  public modelVal = "安卓";
  // public judgeModel() {
  //   let ad_new = this.get_core_data.able_versions.android_new_version;
  //   let ad_old = this.get_core_data.able_versions.android_old_version;
  //   let ios_new = this.get_core_data.able_versions.ios_new_version;
  //   let ios_old = this.get_core_data.able_versions.ios_old_version;
  //   if (
  //     (ad_new !== "" || ad_old !== "") &&
  //     (ios_new !== "" || ios_old !== "")
  //   ) {
  //     this.modelVal = "安卓/iOS";
  //   } else if (ios_new !== "" || ios_old !== "") {
  //     this.modelVal = "iOS";
  //   }
  //   return this.modelVal;
  // }

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.get_core_data.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }

  // 索引分类
  public indexClassification(custom_index: string[]) {
    const settings = JSON.parse(this.get_core_data.settings);
    const index = settings.report_settings.content.index_type;
    let indexClassification: any[] = [];
    indexClassification.push({
      indexClassification: "指标分类",
      dataItem: "数据项",
    });
    (index.basic as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "基础指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.advance as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "深度指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.customize as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    custom_index.forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: item,
        style: { "background-color": "#5d99d5" },
      })
    );
    return indexClassification;
  }
  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }
  // 判断是否出现滚动条
  public scroll = false;

  // 解析邮件收件人
  // public get addressee() {
  //   console.log(JSON.parse(readNewReport(store).settings));
  //   let addressee = JSON.parse(readNewReport(store).settings).report_settings
  //     .notify.email.receiver_str;
  //   this.formMail.addressee = addressee;

  //   return addressee;
  // }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public get RecentTaskList() {
    return readGetTaskList(store);
  }
  public get subTypeList() {
    return [
      { label: "开profile", value: "1" },
      { label: "关profile", value: "2" },
    ];
  }
  public get subTypeList1() {
    return [
      { label: "Default", value: "0" },
      { label: "开profile", value: "1" },
      { label: "关profile", value: "2" },
    ];
  }

  // 报告名称切换时
  public async change_name_search() {
    this.loading = true;
    // 获取当前报告名称列表
    // await dispatchGetNewReportList(store, { project: this.localProject });
    // 报告名称
    // this.name_search = readNewReportList(store)[0].id;
    // 邮件标题
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.name_search),
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    // if (this.get_core_data.auto_roadmap != undefined) {
    //   this.selected_scene1 =
    //     (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
    //   this.imgData = readLivefReport(store).auto_roadmap[0]?.roadmap;
    //   // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
    // }
    this.resBase64 = [];

    this.ecShow = false;
    this.ecShow = true;
    this.corePerformance = [];
    await this.getCorePerformance();
    // await this.dataTable
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    await this.target_types?.forEach((item, index) => {
      if (this.get_core_data.report_list.length > 0) {
        this.$nextTick(() => {
          this.drawPieChart(index, item);
        });
      }
    });

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }

    await this.addressee; //解析邮件收件人

    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备

    this.loading = false;
  }
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask1 = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
    subType: "",
    oldEdition1: [],
    newEdition1: [],
    newEdition2: [],
    is_avg: false,
  };

  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称

  // 打开生成报告
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.generateReportVersion.oldEdition1 = [];
    this.generateReportVersion.newEdition1 = [];
    this.generateReportVersion.is_avg = false;
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  public generateReportsManuallyByTask1() {
    this.dialogFormVisibleByTask1 = true;
    this.generateReportVersion.newEdition2 = [];

    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  //获取下拉选择选项
  // public get getPerformanceSelectOptions() {
  //   return readPerformanceSelectOptions(store);
  // }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  public getp(i) {
    if (i?.length > 0) {
      return i[0];
    } else {
      return i;
    }
  }
  public endText = "";
  public getColor(i) {
    if (i.indexOf("↑") != -1) {
      let startIndex = i.indexOf("↑");
      let endIndex = i.indexOf(")");
      this.endText = i.slice(startIndex, endIndex);
      return i.slice(0, startIndex);
    }
    if (i.indexOf("↓") != -1) {
      let startIndex = i.indexOf("↓");
      let endIndex = i.indexOf(")");
      this.endText = i.slice(startIndex, endIndex);
      return i.slice(0, startIndex);
    } else {
      this.endText = "";
      return i;
    }
  }
  public getColor1(i) {
    if (i.indexOf("↑") != -1) {
      let startIndex = i.indexOf("↑");
      let endIndex = i.indexOf(")");

      return i.slice(startIndex, endIndex);
    }
    if (i.indexOf("↓") != -1) {
      let startIndex = i.indexOf("↓");
      let endIndex = i.indexOf(")");

      return i.slice(startIndex, endIndex);
    } else {
      return "";
    }
  }
  public com(item) {
    if (item.indexOf("↑") != -1) {
      return "red";
    }
    if (item.indexOf("↓") != -1) {
      return "green";
    }
  }
  public com1(item) {
    if (item.indexOf("↑") != -1) {
      return "green";
    }
    if (item.indexOf("↓") != -1) {
      return "red";
    }
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    // const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    // if (
    //   this.generateReportVersion.oldEdition ===
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("版本号不能相同哦！");
    //   return;
    // }
    // if (
    //   this.generateReportVersion.oldEdition >
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("新版本号不能小于旧版本！");
    //   return;
    // }
    this.loading = true;
    this.dialogFormVisible = false;

    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      await dispatchCreateReport(store, {
        //调用创建报告的接口，将所需数据传递过去
        project: this.localProject,
        new_version: this.generateReportVersion.newEdition.split("|")[0],
        old_version: this.generateReportVersion.oldEdition.split("|")[0],
        timestamp: this.generateReportVersion.newEdition.split("|")[1],
        old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
        scene_list: this.generateReportVersion.scenetion,
        report_type: 9,
        subtype: Number(this.generateReportVersion.subType),
        // report_name: this.report_name_placeholder,
      });
    } else {
      await dispatchCreateReport(store, {
        //调用创建报告的接口，将所需数据传递过去
        project: this.localProject,
        new_version: this.generateReportVersion.newEdition.split("|")[0],
        old_version: this.generateReportVersion.oldEdition.split("|")[0],
        timestamp: this.generateReportVersion.newEdition.split("|")[1],
        old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
        scene_list: this.generateReportVersion.scenetion,
        // report_name: this.report_name_placeholder,
      });
    }

    // 获取当前报告名称列表
    // await dispatchGetNewReportList(store, {
    //   project: this.localProject,
    //   report_type: 9,
    // });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 9,
    });
    // 报告名称

    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: readLiveReportList(store)[0].id,
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();

    this.loading = false;
    this.dialogFormVisible = false;
  }
  // 生成报告
  public async generateReportByTask() {
    this.loading = true;
    this.dialogFormVisibleByTask = false;

    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      await dispatchCreateReportByTask(store, {
        //调用创建报告的接口，将所需数据传递过去
        project: this.localProject,
        task_record_id: this.generateReportVersion.newEdition1.join("、"),
        old_record_id: this.generateReportVersion.oldEdition1.join("、"),
        report_type: 9,
        is_avg: this.generateReportVersion.is_avg,
        // subtype:Number(this.generateReportVersion.subType)
      });
    } else {
      await dispatchCreateReportByTask(store, {
        //调用创建报告的接口，将所需数据传递过去
        project: this.localProject,
        task_record_id: Number(this.generateReportVersion.newEdition),
        old_record_id: Number(this.generateReportVersion.oldEdition),
      });
    }

    // 获取当前报告名称列表
    // await dispatchGetNewReportList(store, {
    //   project: this.localProject,
    //   report_type: 9,
    // });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 9,
    });
    // 报告名称
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: readLiveReportList(store)[0].id,
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });

    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    await this.addressee; //解析邮件收件人
    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }
  public async generateReportByTask1() {
    this.loading = true;
    this.dialogFormVisibleByTask1 = false;

    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: this.generateReportVersion.newEdition2.join("、"),
      old_record_id: "",
      report_type: 9,
      is_avg: 1,
      // subtype:Number(this.generateReportVersion.subType)
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 9,
    });

    // 报告名称
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: readLiveReportList(store)[0].id,
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }

  // 激活报告名称
  // public activation(val: boolean) {
  //   if (val) {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition;
  //   } else {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition.split("|")[0];
  //   }
  // }

  // 得到项目名称
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }

  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }
  public get dataTable() {
    let list = [
      "avg_fps",
      "max_pss",
      "avg_cpu",
      "loadingtime",
      "experienceLoadingTime",
    ];
    //     list.forEach((v:any)=>{
    //       v.data=[]
    //       this.get_core_data.report_list.forEach(k=>{
    //           v.data.push({new:k.new,old:k.old,scene:k.scene,device:k.new.map(n=>n.device)
    // })
    //       })
    //     })
    return list;
  }
  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }
  public getCorePerformance() {
    if (this.get_core_data.report_list.length > 0) {
      this.corePerformance.push({
        title: "新场景:",
        data: this.get_core_data.report_list,
        compare: this.get_core_data.core_devices,
      });
    }

    return this.corePerformance;
  }
  public getData(type, data) {
    let list = [];
    if (type == "loadingtime" || type == "experienceLoadingTime") {
      list.push(data[0]);
      return list;
    } else {
      return data;
    }
  }
  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      report_id: Number(this.$route.query.report_id),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口

    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.$route.query.report_id),
    // });
    await dispatchGetLiverfReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });
    //启用生成报告的接口
    await this.get_create_report();
    await this.perf_report();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    let settings = JSON.parse(this.new_report.settings);
    this.target_all = {};
    let nameLabel = "5V5真人PVP剧本";
    this.target_all[nameLabel] = {};
    this.target_types.map((item, index) => {
      this.target_all[nameLabel][item] = [];
    });
    for (let i in this.target_all) {
      if (settings.label_formatter) {
        if (settings?.label_formatter[i]) {
          for (let k in settings.label_formatter[i]) {
            this.target_all[i][k] = settings.label_formatter[i][k];
          }
        }
      }
    }
    this.$nextTick(() => {
      this.target_types?.forEach((item, index) => {
        this.drawPieChart(index, item);
      });
    });
    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }
  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }
}
